import type { RestConnectorConfig } from "oi-ecp-data-connector";
import { Public } from "oi-ecp-data-connector";

import { DataConnectorBase } from "./dataConnectorBase";
import type { RoleContextResponse } from "../redux/clients/clientsTypes";

// API base URL from environment variable (baked at build time)
const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  "https://dev06-template-builder-api.optum.com";


// This we added to support Automation testing 
const queryId =
  typeof window !== "undefined" ? window.sessionStorage.getItem("queryId") : null;


const config: RestConnectorConfig = {
  baseUrl: API_BASE_URL,
  defaultHeaders: {
    "Content-Type": "application/json",
  },
  restApiConfig: {
    getClientsByPlatform: {
      url: queryId
        ? `/usr/profile?id=${encodeURIComponent(queryId)}`
        : "/usr/profile",
      method: "GET",
    },
  },
};

export class ClientsDataConnector extends DataConnectorBase {
  constructor() {
    super(config);
  }

  @Public({
    description: "Get role context using the stored access token.",
    example:
      "const data = await new ClientsDataConnector().getClientsByPlatform()",
  })
  async getClientsByPlatform(): Promise<RoleContextResponse> {
    await this.setEndpointAuthHeader("getClientsByPlatform");
    return this.restCallStrict<RoleContextResponse>("getClientsByPlatform", null);
  }
}
